import { useState } from 'react';
import { PropTypes } from 'prop-types';
import { useForm, FormProvider } from 'react-hook-form';
import { InputControlled } from 'components/UI/InputControlled/InputControlled';
import { yupResolver } from '@hookform/resolvers/yup';
import { registrationFormSchema } from 'utils/form-validation-schema';
import { saveGuestRegistrationInformation } from 'services/UserAccountService';
import parse from 'html-react-parser';

export const RegistrationForm = (props) => {
  const { RegisterButtonText = 'Continue registration' } = props;
  const [isProcessing, setIsProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(registrationFormSchema),
  });
  const {
    formState: { isValid },
  } = methods;

  const onSubmitHandler = async (formData) => {
    setIsProcessing(true);

    const response = await saveGuestRegistrationInformation(formData);
    const errorMessageText = response?.RegisterErrorMessage;

    if (errorMessageText) {
      setErrorMessage(errorMessageText);
      setIsProcessing(false);
    } else {
      window.location.href = response?.RedirectUrl;
    }
  };

  const errorMessageSnippet = (
    <div className="callout-row">
      <div className="callout-container callout-error">
        <p>
          <strong>Sorry! </strong>
          <small>{parse(errorMessage)}</small>
        </p>
      </div>
    </div>
  );

  return (
    <FormProvider {...methods}>
      <form
        name="newUserForm"
        noValidate
        onSubmit={methods.handleSubmit(onSubmitHandler)}
        data-testid="registration-form"
      >
        <div className="box-bordered border-double border-transparent">
          <div className="row">
            <div className="col-sm-12 col-md-8 col-md-offset-2">
              <h2 className="h5 hidden-xs">New to Arts Centre Melbourne?</h2>
              <p>
                Create an account by providing your name and email address. Please see our{' '}
                <a href="https://www.artscentremelbourne.com.au/privacy-policy">
                  Privacy Statement
                </a>{' '}
                for what this means. Don't want to create an account? Please contact the{' '}
                <a href="https://www.artscentremelbourne.com.au/contact-us">Box Office</a> to
                purchase tickets.
              </p>
              <div className="form-group">
                <InputControlled
                  id="inputFirstNameContinue"
                  labelText="First name"
                  error={methods.formState.errors.inputFirstNameContinue}
                  hideErrorMsgForRequired
                />
              </div>
              <div className="form-group">
                <InputControlled
                  id="inputLastNameContinue"
                  labelText="Last name"
                  error={methods.formState.errors.inputLastNameContinue}
                  hideErrorMsgForRequired
                />
              </div>
              <div className="form-group">
                <InputControlled
                  type="email"
                  id="inputEmailContinue"
                  labelText="Email address"
                  error={methods.formState.errors.inputEmailContinue}
                  hideErrorMsgForRequired
                />
              </div>
              {errorMessage && errorMessageSnippet}
              <br />
              <button
                type="submit"
                className="btn btn-secondary btn-signin"
                disabled={!isValid || isProcessing}
                data-testid="registration-button"
              >
                <span>{isProcessing ? 'Processing...' : RegisterButtonText}</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

RegistrationForm.propTypes = {
  RegisterButtonText: PropTypes.string,
};

export const RegistrationFormSC = (props) => {
  const { sitecoreData } = props;
  return <RegistrationForm {...sitecoreData} />;
};

RegistrationFormSC.propTypes = {
  sitecoreData: PropTypes.object,
};
